import { useLocation, useNavigate } from "react-router-dom";
import './Sidebar.css';
import withCssScope from '../withCssScope';

const Sidebar = ({ isMenuOpen, toggleMenu }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavClick = (e, targetId) => {
    e.preventDefault(); // Prevent default anchor behavior
    toggleMenu(); // Close the sidebar

    if (location.pathname !== "/") {
      // Navigate to home first, then scroll
      navigate(`/#${targetId}`);
    } else {
      // Scroll smoothly to section
      setTimeout(() => {
        const element = document.getElementById(targetId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  };

  const menuItems = [
    { name: "Home", icon: "fa-home" },
    { name: "Features", icon: "fa-star" },
    { name: "How it works", icon: "fa-rocket" },
    { name: "About", icon: "fa-info-circle" },
    { name: "Contact", icon: "fa-envelope" }
  ];

  return (
    <>
      {/* Overlay */}
      <div
        className={`sidebar-overlay ${isMenuOpen ? 'active' : ''}`}
        onClick={toggleMenu}
      />

      {/* Sidebar */}
      <div
        id="mobile-sidebar"
        className={`sidebar-container ${isMenuOpen ? 'open' : ''}`}
      >
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <img src="/assets/images/proRenter-Icon.png" alt="Prorenter" />
            <h3>Prorenter</h3>
          </div>
          <button className="sidebar-close-btn" onClick={toggleMenu}>
            ×
          </button>
        </div>

        <ul className="sidebar-nav">
          {menuItems.map((item, index) => {
            const targetId = item.name.toLowerCase().replace(/\s+/g, "-");

            return (
              <li key={index} className="sidebar-item">
                <a href={`#${targetId}`} onClick={(e) => handleNavClick(e, targetId)}>
                  <i className={`fa-solid ${item.icon}`}></i>
                  <span>{item.name}</span>
                </a>
              </li>
            );
          })}
        </ul>

        <div className="sidebar-footer">
          <p className="sidebar-social-title">Follow Us</p>
          <div className="sidebar-social">
            {[
              { link: "https://www.facebook.com/profile.php?id=61573526260313", icon: "fa-facebook-f" },
              { link: "https://x.com/Prorenter182683", icon: "fa-x-twitter" },
              { link: "https://www.instagram.com/prorenter.app?igsh=MTNjcTU3NGpobXU1eg==", icon: "fa-instagram" },
              { link: "https://www.linkedin.com/company/106638928", icon: "fa-linkedin-in" },
            ].map(({ link, icon }, index) => (
              <a key={index} href={link} target="_blank" rel="noopener noreferrer">
                <i className={`fa-brands ${icon}`}></i>
              </a>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default withCssScope(Sidebar, 'scope-sidebar');